import { render, staticRenderFns } from "./dialogueM0.vue?vue&type=template&id=6cfd2efb&"
import script from "./dialogueM0.vue?vue&type=script&lang=js&"
export * from "./dialogueM0.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports